<template>
  <div class="sky-server-config">
    <div class="wsp-display-flex wsp-line-height-28 wsp-padding-tb-3">
      <div class="wsp-width-30 wsp-text-align-right ">
        <span><label style="color: red;">* </label>{{ lang.t('pocMng.requestConfirm') }}：</span>
      </div>
      <div class="wsp-width-70 ">
        <el-radio-group v-model="requestConfirm">
          <el-radio-button label="Y" value="Y">是</el-radio-button>
          <el-radio-button label="N" value="N">否</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="wsp-display-flex wsp-line-height-28">
      <div class="wsp-width-30 wsp-text-align-right">
        <span>{{ lang.t('pocMng.requestConfirmContent') }}：</span>
      </div>
      <div class="wsp-width-70">
        <el-input type="textarea" :rows="5" placeholder="无" v-model="requestConfirmContent"> </el-input>
      </div>
    </div>

    <div style="text-align: center; margin-top: 10px;">
      <el-button type="primary" class="sky-branch-pattern__add" style="margin-top:5px" @click="onConfirm">
        确定
      </el-button>
      <el-button class="sky-branch-pattern__add" style="margin-top:5px" @click="onCancel">
        取消
      </el-button>
    </div>
  </div>
</template>
<script type="text/babel">
import { Input, Button, RadioButton, RadioGroup } from 'element-ui'

import { SetRequestConfirm } from '@/api/project'
import lang from '@/lang'
export default {
  name: 'SkyRequestConfirmDialog',
  inject: ['rootView', 'elForm'],
  components: {
    [Input.name]: Input,
    [RadioButton.name]: RadioButton,
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup
  },
  props: {
    row: {}
  },
  data() {
    return {
      projectId: null,
      requestConfirm: 'N',
      requestConfirmContent: null,
      lang: lang
    }
  },
  mounted() {
    this.projectId = this.row.id
  },
  watch: {},
  methods: {
    onConfirm() {
      SetRequestConfirm({
        projectId: this.projectId,
        requestConfirm: this.requestConfirm,
        requestConfirmContent: this.requestConfirmContent
      })
        .then(res => {
          this.$store.dispatch('OpenNotification', { message: '方案确认成功', type: 'success' })
          this.$emit('cb')
        })
        .catch(e => {
          this.$emit('cb')
          throw e
        })
    },
    onCancel() {
      this.$emit('cb')
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(version-variable) {
  @include e(more-btn) {
    & .el-button {
      background-color: $--fill-base !important;
      color: $--color-primary !important;
      border: 0 !important;
      line-height: $--font-line-height-base - 0.2em;
      &:hover {
        color: $--color-primary-5 !important;
      }
    }
  }
}
@include b(server-config) {
  margin-bottom: 0px !important;
  @include e(autocomplete) {
    width: auto !important;
    min-width: 180px;
  }
  @include e(select) {
    width: 180px !important;
  }
  @include e(mutiple-select) {
    width: 300px !important;
  }
  @include e(item) {
    line-height: 30px;
    word-break: break-all;
    width: 1400px !important;
    color: $--disabled-color-base;
    &.active {
      color: $--color-primary;
    }
  }
  & i {
    margin-right: 5px;
  }
  & .el-input__inner {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    padding: 0;
  }
  & .el-form-item__error {
    width: 500px !important;
  }
}
</style>
